<template>
  <div class="index">
    <swiper
      :options="swiperOption"
      class="swiper"
      ref="mySwiper"
      v-if="wapSwipers.length > 0"
    >
      <swiper-slide v-for="(item, index) in wapSwipers" :key="index">
        <!-- 解决动态加载空白页问题 -->
        <img style="width: 100%; height: 160px" :src="item.image_url" alt="" />
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
    <div class="content">
      <!-- 企业简介 -->
      <div class="introduction-box">
        <div class="wap-common-title">
          <h1>企业<span>简介</span></h1>
          <p>Introduction</p>
        </div>
        <div class="introduction">
          北京沃沃智慧农贸集团有限公司以农贸、农批市场的智慧化建设改造和运营管理为基础，通过智慧市场管理系统、交易及即时分账系统、供应链管理系统、食品安全管理系统、垂直电商平台等系统平台的应用，实现商流、物流、信息流、资金流一体化；以线上线下一体化的农贸市场为依托，数字化赋能生鲜全产业链，构建农贸及农批完整的食材供应链及流通体系；以覆盖人流庞大、千万级复购家庭、数百亿交易金额的县市中心市场为基础，构建区域及省级名优特新产品的选品中心及供应链业务，大力发展线上线下一体化电商业务以及定位中高端、面向全网消费者的公域电商业务，打造“一个底座，三位一体”的沃沃农贸品牌供应链及大数据服务体系。
        </div>
      </div>
      <!-- 沃沃农贸 -->
      <div class="vv-life">
        <div class="wap-common-title">
          <h1>沃沃<span>农贸</span></h1>
          <p>VV Life</p>
        </div>
        <div class="vv-life-box">
          <div
            class="vv-life-item"
            v-for="(item, index) in vvLife"
            :key="index"
          >
            <img class="vv-life-image" :src="item.image_show" />
            <div class="vv-life-nav">
              <p>{{ item.title }}</p>
              <span>{{ item.sub_title }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 战略布局 -->
      <div class="strategic">
        <div class="wap-common-title">
          <h1>战略<span>布局</span></h1>
          <p>Strategic Layout</p>
        </div>
        <div class="strategic-layout">
          <p>
            深耕国内重点城市，借助资本力量辐射拓展至全国，重点战略布局<b>广东、广西、海南、山东、浙江、江苏、河南、云南、贵州、四川、福建、湖北、湖南</b>等省市。
          </p>
          <p>
            <b>截至2022年6月</b
            >，沃沃农贸已在广西、广东、山东、河南、贵州、湖北、福建等<b
              >二十多个地级市开展业务。</b
            ><b style="font-size:13px;color:red"
              >目前沃沃农贸已成为国内农贸市场二批+零售领域签约市场规模、自研科技系统应用的行业龙头企业</b
            >。
          </p>
          <p>
            预计<b>2025年</b>实现管理覆盖达<b>100个</b>以上国内重点城市（含县级市），管理市场数量超<b>1200家</b>。
          </p>

          <div class="strategic-map">
            <img src="@/assets/images/index/wap_map.png" />
          </div>
        </div>
      </div>
      <!-- 市场定位 -->
      <div class="market-position">
        <div class="wap-common-title">
          <h1>市场<span>定位</span></h1>
          <p>Market Position</p>
        </div>
        <div class="market-position-box">
          <div
            class="market-position-item"
            v-for="(item, index) in marketPosition"
            :key="index"
          >
            <img class="market-position-img" :src="item.img" />
            <div class="market-position-nav">
              <h1>{{ item.text }}</h1>
              <p>{{ item.name }}{{ item.namelist }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 经典案例 -->
      <div class="successful">
        <div class="wap-common-title">
          <h1>经典<span>案例</span></h1>
          <p>Classic Cases</p>
        </div>
        <div class="wap-list">
          <div
            class="wap-list-item"
            v-for="(item, index) in casesList"
            :key="index"
            @click="goCasesDetail(item.id)"
          >
            <el-image
              style="width: 100%; height: 100px"
              :src="item.image_url"
              fit="cover"
            ></el-image>
            <p class="title-mask one-write">
              {{ item.title }}
            </p>
          </div>
        </div>
        <button class="wap-common-more-button" @click="goSuccessfulCase()">
          查看更多
        </button>
      </div>
      <!-- 资质荣誉 -->
      <div class="qualification">
        <div class="wap-common-title">
          <h1>资质<span>荣誉</span></h1>
          <p>Qualification and Honors</p>
        </div>
        <WapQualification></WapQualification>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import WapQualification from "@/components/WapQualification";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "index",
  metaInfo: {
    title: "首页--中国智慧农贸领军企业",
    meta: [
      {
        name: "Keywords",
        content:
          "沃沃农贸集团,北京沃沃农贸,智慧农贸市场招商,智慧批发市场,沃沃智慧农贸市场,菜篮子工程,菜市场品牌,菜市场运营,菜市场改造,菜市场升级,农贸市场运营,智慧菜市场"
      },
      {
        name: "description",
        content: "沃沃农贸-中国智慧农贸领军企业"
      }
    ],

    link: [
      {
        rel: "asstes",
        href: "http://www.sinvocloud.com/"
      }
    ]
  },
  components: {
    WapQualification
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        observer: true,
        observeParents: true,
        initialSlide: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["getWapSwiper", "getCasesList"]),
    init() {
      this.getWapSwiper();

      let data = {
        per_page: 4,
        page: 1,
        category_id: 2 //1农批 2农贸
      };
      this.getCasesList(data);
    },
    goCasesDetail(id) {
      this.$router.push({
        name: "successful-cases-show",
        query: {
          id: id
        }
      });
    },
    goSuccessfulCase() {
      this.$router.push({ name: "successful-cases" });
    }
  },
  computed: {
    ...mapGetters(["wapSwipers", "vvLife", "marketPosition", "casesList"])
  }
};
</script>
<style scoped>
@import url("../../../assets/css/wap-list.css");
.index {
  width: 100%;
}
.swiper img {
  width: 100%;
}
.swiper-pagination {
  width: 100%;
  text-align: center;
  margin-top: -50px;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  border: 1px solid #fff;
  background: none;
  margin: 0 3px;
  opacity: 1;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background: #fff;
}
.content {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 3%;
}
.introduction-box {
  position: relative;
  background: url("../../../assets/images/index/wap_top_bg.png");
  background-size: 100% 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 30px 30px;
  margin: -40px 0 20px;
  z-index: 9;
}
.introduction {
  margin-top: 30px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 1.8;
  text-indent: 24px;
  text-align: justify;
}
.vv-life-box {
  margin: 20px 0 40px;
}
.vv-life-item {
  background: linear-gradient(0deg, #01d0b6, #21e4ab);
  box-shadow: 0px 3px 5px 0px rgba(2, 208, 182, 0.35);
  border-radius: 10px;
  padding: 30px 25px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.vv-life-item .vv-life-image {
  width: 35px;
  height: 35px;
  margin-right: 18px;
}
.vv-life-nav {
  font-size: 14px;
  color: #fff;
}
.vv-life-nav span {
  font-size: 12px;
}
.strategic {
  margin-bottom: 30px;
}
.strategic-layout {
  margin-top: 30px;
}
.strategic-layout p {
  padding-left: 15px;
  background: url("../../../assets/images/index/qualifi.png") no-repeat;
  background-size: 8px 8px;
  background-position: 0 8px;
  text-align: justify;
  line-height: 1.5;
  margin-bottom: 10px;
  color: #666;
  font-size: 12px;
}
.strategic-layout p b {
  color: #333;
}
.strategic-layout-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.strategic-left {
  flex: 1;
}
.strategic-map {
  width: 100%;
}
.strategic-map img {
  width: 100%;
  height: auto;
}
.strategic-left p:nth-last-of-type(1) {
  margin-bottom: 0;
}
.market-position {
  margin: 20px 0 40px;
}
.market-position-box {
  margin-top: 40px;
}
.market-position-item {
  background: #fff;
  box-shadow: 0px 3px 10px 0px rgba(204, 204, 204, 0.3);
  border-radius: 10px;
  padding: 25px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.market-position-img {
  width: 35px;
  height: 35px;
  margin-right: 10px;
}
.market-position-nav {
  font-size: 14px;
  color: #333;
}
.market-position-nav p {
  font-size: 12px;
  color: #666;
}
.successful {
  margin-bottom: 20px;
}
.successful .wap-list {
  margin: 20px 0 -5px;
}
.successful .wap-list-item {
  position: relative;
  height: 100px;
}
.successful .title-mask {
  width: 100%;
  height: 26px;
  line-height: 26px;
  box-sizing: border-box;
  padding: 0 10%;
  background: rgba(51, 51, 51, 0.5);
  position: absolute;
  bottom: 0px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgb(255, 255, 255);
  text-align: center;
}
.qualification,
.qualification .wap-common-title {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/wap/index/Index.vue